(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["announcement-bar"] && !Shopify.designMode) return;
  try {
    (() => {
    let timer;
    function syncMirrorWorldOffer() {
      clearTimeout(timer);
      const now = Date.now();
      const start = 1792666800000, end = 1793012399000;
      const percent = now >= start && now < end ? 25 : 0;
      document.querySelectorAll('[data-mw-offer-region]').forEach(node => { node.hidden = !percent; });
      document.querySelectorAll('[data-mw-offer-fallback]').forEach(node => { node.hidden = Boolean(percent); });
      if (percent) {
        const deadline = 'Monday 26 October, 11:59 PM NZDT';
        document.querySelectorAll('[data-mw-offer-percent]').forEach(node => { node.textContent = percent; });
        document.querySelectorAll('[data-mw-offer-deadline]').forEach(node => { node.textContent = deadline; });
        document.querySelectorAll('[data-mw-stage-25]').forEach(node => { node.textContent = node.getAttribute('data-mw-stage-' + percent); });
      }
      const next = now < start ? start : end;
      if (now < end) timer = setTimeout(syncMirrorWorldOffer, Math.min(Math.max(next - now, 1), 60000));
    }
    document.addEventListener('visibilitychange', syncMirrorWorldOffer);
    document.addEventListener('shopify:section:load', syncMirrorWorldOffer);
    window.addEventListener('pageshow', syncMirrorWorldOffer);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncMirrorWorldOffer, {once: true});
    else syncMirrorWorldOffer();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mw-promo-price"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mw-promo-price')) {
    customElements.define('mw-promo-price', class extends HTMLElement {
      connectedCallback() {
        const data = this.querySelector('[data-mw-price-variants]');
        this.variants = data ? JSON.parse(data.textContent) : null;
        this.productContainer = this.closest('.product-section');
        this.hasVariant = true;
        this.variantHandler = event => {
          const variant = event.detail && event.detail.variant;
          if (!this.variants) return;
          this.hasVariant = Boolean(variant && this.variants[String(variant.id)]);
          if (this.hasVariant) this.dataset.variantId = String(variant.id);
          this.syncOffer();
        };
        this.visibilityHandler = () => this.syncOffer();
        if (this.variants && this.productContainer) this.productContainer.addEventListener('variantChange', this.variantHandler);
        document.addEventListener('visibilitychange', this.visibilityHandler);
        window.addEventListener('pageshow', this.visibilityHandler);
        this.syncOffer();
      }
      syncOffer() {
        clearTimeout(this.offerTimer);
        const now = Date.now();
        const start = 1792666800000, end = 1793012399000;
        const percent = now >= start && now < end ? 25 : 0;
        this.hidden = !this.hasVariant || !percent;
        if (!this.hidden) {
          const prices = this.variants && this.variants[this.dataset.variantId];
          if (prices) this.querySelector('[data-mw-regular]').textContent = prices.regular;
          this.querySelector('[data-mw-discounted]').textContent = prices ? prices[percent] : this.getAttribute('data-price-' + percent);
          this.querySelector('.mw-promo-price__label').textContent = this.getAttribute('data-label-' + percent);
          this.querySelector('[data-mw-accessible]').textContent = this.getAttribute('data-accessible-' + percent);
          const deadline = this.querySelector('[data-mw-price-deadline]');
          const note = this.querySelector('[data-mw-price-note]');
          if (deadline) deadline.textContent = deadline.getAttribute('data-copy-' + percent);
          if (note) note.textContent = note.getAttribute('data-copy-' + percent);
        }
        const next = now < start ? start : end;
        if (now < end) this.offerTimer = setTimeout(() => this.syncOffer(), Math.min(Math.max(next - now, 1), 60000));
      }
      disconnectedCallback() {
        clearTimeout(this.offerTimer);
        if (this.productContainer) this.productContainer.removeEventListener('variantChange', this.variantHandler);
        document.removeEventListener('visibilitychange', this.visibilityHandler);
        window.removeEventListener('pageshow', this.visibilityHandler);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
